/*jshint esversion: 9 */
import { connect } from "react-redux";
import React, { Component, Fragment } from "react";
// import { useLocation } from "react-router";
import { doLog, getAppOptions, hasValue } from "../../../shared/utility";

import Auth from "../../../containers/Auth/Auth";
// import Header from '../containers/Header';
import CrimeSubmission from "../../../containers/CrimeSubmission";
import Footer from "../../../containers/Footer";
// import ManageDB from "../../../containers/ManageDB/ManageDB";
import NavigationButtonItems from "../NavigationButtonItems/NavigationButtonItems";

import classes from "./LandingPage.css";
// import "./LandingPage.css";

class LandingPage extends Component {
  state = {
    navigationButtonItems: null,
  };

  componentDidMount() {
    // if (doLog()) console.log(
    //   "LandingPage.componentDidMount userGroup:" + this.props.userGroup
    // );
    if (doLog())
      console.log(
        "LandingPage.componentDidMount modulePermissions:",
        this.props.modulePermissions
      );
    if (
      hasValue(this.props.modulePermissions) &&
      this.state.navigationButtonItems === null
    ) {
      this.setState({
        navigationButtonItems: (
          <NavigationButtonItems
            modulePermissions={this.props.modulePermissions}
          />
        ),
      });
    }
  }

  componentDidUpdate() {
    if (doLog())
      console.log(
        "LandingPage.componentDidUpdate modulePermissions:",
        this.props.modulePermissions
      );
    if (
      hasValue(this.props.modulePermissions) &&
      this.state.navigationButtonItems === null
    ) {
      this.setState({
        navigationButtonItems: (
          <NavigationButtonItems
            modulePermissions={this.props.modulePermissions}
          />
        ),
      });
    }
  }

  render() {
    // if (doLog()) console.log("LandingPage.render");
    if (doLog()) console.log("LandingPage.render props:", this.props);
    if (doLog())
      console.log("LandingPage.render agencyCode:", this.props.agencyCode);
    let errorSection = null;
    let mainSection = null;
    if (hasValue(this.props.agencyCode)) {
      // if (doLog()) console.log("LandingPage.render agencyCode found");
      let authNeeded = false;
      const appOptions = getAppOptions();
      if (doLog()) console.log("LandingPage appOptions:", appOptions);
      const permissionOption = appOptions["fbr"];
      if (
        hasValue(permissionOption) &&
        permissionOption.toUpperCase().startsWith("T")
      ) {
        authNeeded = true;
      }
      if (doLog()) console.log("LandingPage.render authNeeded:" + authNeeded + " isAuthenticated:" + this.props.isAuthenticated);
      if (authNeeded && !this.props.isAuthenticated) {
        mainSection = (
          <Auth />
        );
      } else {
        mainSection = (
          <Fragment>
            <CrimeSubmission />
            <Footer />
          </Fragment>
        );
      }
    } else {
      errorSection = (
        <Fragment>
          <h2 className={classes.HeaderTitle}>
            Welcome to the electronic Community Online Portal (eCOP).
          </h2>
          <p className={classes.FormHeader}>No agency was specified</p>
        </Fragment>
      );
    }

    if (this.props.agencyCode === "admin") {
      if (this.props.isAuthenticated) {
        mainSection = (
          <div className={[classes.LandingPage, classes.FullHeight].join(" ")}>
            <nav className={classes.FullHeight}>
              {this.state.navigationButtonItems}
            </nav>
          </div>
        );
      } else {
        mainSection = null;
      }
    }

    return (
      <div className={[classes.LandingPage, classes.FullHeight].join(" ")}>
        {errorSection}
        {mainSection}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  if (doLog()) console.log("LandingPage.mapStateToProps state:", state);
  // if (doLog()) console.log('LandingPage.mapStateToProps token:', state.auth.token);
  return {
    loading: state.auth.loading,
    error: state.auth.error,
    isAuthenticated: state.auth.token !== null,
    authRedirectPath: state.auth.authRedirectPath,
    agencyCode: state.trans.agencyCode,
    modulePermissions: state.auth.modulePermissions,
  };
};

export default connect(mapStateToProps)(LandingPage);
